module.exports = __webpack_public_path__ + "static/media/web-analytics.148c417e.svg";